import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function CosmeticIngredients() {
  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-20 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/585e39c55214082cc6a96c58e80ddaf9.jpg)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">化粧品原料の開発・製造・販売</h1>
          <p className="text-lg md:text-xl mb-8 opacity-95">
            幹細胞由来エクソソーム（エキソソーム）を活用した革新的な美容成分の提供
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-gradient-to-br from-pink-50 to-purple-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-800">
              次世代美容成分の開発・製造
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Exosome Oneは、幹細胞培養技術とバイオテクノロジーを活用して、
              化粧品業界に革新をもたらす高機能美容成分を開発・製造・販売しています。
            </p>
          </div>

          {/* Key Products */}
          <div className="grid md:grid-cols-3 gap-8 mb-20">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=High-end%20exosome%20beauty%20serum%20with%20microscopic%20particles%20visible%2C%20luxury%20cosmetic%20product%20development%20laboratory%20with%20stem%20cell%20derived%20ingredients%2C%20advanced%20skincare%20formulation%20with%20growth%20factors%20and%20peptides%2C%20clean%20modern%20biotechnology%20facility%20for%20cosmetic%20manufacturing%2C%20premium%20beauty%20products%20with%20cellular%20regeneration%20technology&width=400&height=240&seq=exosome-beauty-serum-2024&orientation=landscape"
                alt="エクソソーム美容液"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-4 text-gray-800">エクソソーム（エキソソーム）配合美容液</h3>
                <ul className="space-y-2 text-sm text-gray-700 mb-4">
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-pink-500 mt-0.5 flex-shrink-0"></i>
                    <span>細胞レベルでの肌再生促進</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-pink-500 mt-0.5 flex-shrink-0"></i>
                    <span>コラーゲン産生の活性化</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-pink-500 mt-0.5 flex-shrink-0"></i>
                    <span>アンチエイジング効果</span>
                  </li>
                </ul>
                <span className="text-xs bg-pink-100 text-pink-700 px-3 py-1 rounded-full font-medium">プレミアム成分</span>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Stem%20cell%20culture%20supernatant%20liquid%20in%20laboratory%20containers%2C%20advanced%20biotechnology%20facility%20for%20cell%20culture%20medium%20extraction%2C%20scientists%20working%20with%20cell%20culture%20solutions%20for%20cosmetic%20applications%2C%20clean%20sterile%20environment%20with%20bioreactors%20and%20culture%20flasks%2C%20high-quality%20cell-derived%20beauty%20ingredients&width=400&height=240&seq=stem-cell-supernatant-2024&orientation=landscape"
                alt="幹細胞培養上清液"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-4 text-gray-800">幹細胞培養上清液</h3>
                <ul className="space-y-2 text-sm text-gray-700 mb-4">
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-purple-500 mt-0.5 flex-shrink-0"></i>
                    <span>成長因子の豊富な含有</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-purple-500 mt-0.5 flex-shrink-0"></i>
                    <span>肌細胞の活性化</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-purple-500 mt-0.5 flex-shrink-0"></i>
                    <span>自然治癒力の向上</span>
                  </li>
                </ul>
                <span className="text-xs bg-purple-100 text-purple-700 px-3 py-1 rounded-full font-medium">バイオ活性成分</span>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Specialized%20growth%20factors%20and%20peptides%20for%20cosmetic%20formulation%2C%20advanced%20biotechnology%20laboratory%20with%20protein%20synthesis%20equipment%2C%20scientists%20developing%20bioactive%20peptides%20for%20skincare%20applications%2C%20clean%20modern%20facility%20with%20specialized%20peptide%20manufacturing%20systems%2C%20high-tech%20cosmetic%20ingredient%20production&width=400&height=240&seq=growth-factors-peptides-2024&orientation=landscape"
                alt="成長因子・ペプチド"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-4 text-gray-800">成長因子・ペプチド</h3>
                <ul className="space-y-2 text-sm text-gray-700 mb-4">
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-teal-500 mt-0.5 flex-shrink-0"></i>
                    <span>ターゲット別機能性ペプチド</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-teal-500 mt-0.5 flex-shrink-0"></i>
                    <span>高純度・高活性</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-teal-500 mt-0.5 flex-shrink-0"></i>
                    <span>カスタマイズ対応</span>
                  </li>
                </ul>
                <span className="text-xs bg-teal-100 text-teal-700 px-3 py-1 rounded-full font-medium">機能性成分</span>
              </div>
            </div>
          </div>

          {/* Manufacturing Process */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-20">
            <h3 className="text-2xl font-bold mb-8 text-center text-gray-800">製造プロセス</h3>
            
            <div className="grid md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-pink-500 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-flask-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">細胞培養</h4>
                <p className="text-sm text-gray-600">
                  厳選した幹細胞を無菌環境下で大量培養
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-filter-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">成分抽出</h4>
                <p className="text-sm text-gray-600">
                  特殊技術による高純度成分の抽出・精製
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">品質管理</h4>
                <p className="text-sm text-gray-600">
                  GMP準拠の厳格な品質検査と安全性評価
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">製品化</h4>
                <p className="text-sm text-gray-600">
                  顧客ニーズに応じたカスタム製剤化と配送
                </p>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h3 className="text-2xl font-bold mb-6 text-gray-800">提供サービス</h3>
              
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-pink-500 to-purple-500 rounded-full flex items-center justify-center">
                    <i className="ri-test-tube-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2 text-gray-800">OEM・ODM製造</h4>
                    <p className="text-sm text-gray-600">
                      化粧品メーカー様のブランドに合わせた製品開発・製造を一貫してサポート。
                      小ロットから大量生産まで柔軟に対応いたします。
                    </p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-teal-500 to-blue-500 rounded-full flex items-center justify-center">
                    <i className="ri-lightbulb-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2 text-gray-800">共同開発</h4>
                    <p className="text-sm text-gray-600">
                      お客様の製品コンセプトに基づき、独自の美容成分を活用した
                      革新的な化粧品の共同開発を行います。
                    </p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                    <i className="ri-shield-check-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2 text-gray-800">品質保証・認証サポート</h4>
                    <p className="text-sm text-gray-600">
                      国際基準に準拠した品質管理体制により、安全性データの提供から
                      各種認証取得まで包括的にサポートします。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20cosmetic%20formulation%20laboratory%20with%20scientists%20developing%20luxury%20skincare%20products%2C%20modern%20biotechnology%20facility%20for%20high-end%20beauty%20manufacturing%2C%20researchers%20testing%20cosmetic%20ingredients%20and%20creating%20innovative%20formulations%2C%20clean%20white%20laboratory%20environment%20with%20sophisticated%20equipment%20for%20cosmetic%20product%20development%2C%20quality%20control%20testing%20for%20premium%20beauty%20products&width=600&height=400&seq=cosmetic-formulation-lab-2024&orientation=landscape"
                alt="化粧品開発サービス"
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
            </div>
          </div>

          {/* Quality Standards */}
          <div className="bg-gradient-to-br from-teal-600 to-purple-600 text-white rounded-2xl p-8 md:p-12 mb-20">
            <h3 className="text-2xl font-bold mb-8 text-center">品質管理基準</h3>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <i className="ri-award-line text-4xl mb-4 opacity-90"></i>
                <h4 className="font-bold mb-2">GMP準拠</h4>
                <p className="text-sm opacity-90">医薬品レベルの製造品質管理</p>
              </div>
              <div className="text-center">
                <i className="ri-shield-check-line text-4xl mb-4 opacity-90"></i>
                <h4 className="font-bold mb-2">安全性試験</h4>
                <p className="text-sm opacity-90">厳格な毒性・アレルギー試験</p>
              </div>
              <div className="text-center">
                <i className="ri-microscope-line text-4xl mb-4 opacity-90"></i>
                <h4 className="font-bold mb-2">品質分析</h4>
                <p className="text-sm opacity-90">成分純度・活性度の精密測定</p>
              </div>
              <div className="text-center">
                <i className="ri-file-text-line text-4xl mb-4 opacity-90"></i>
                <h4 className="font-bold mb-2">トレーサビリティ</h4>
                <p className="text-sm opacity-90">原料から製品まで完全追跡</p>
              </div>
            </div>
          </div>

          {/* Benefits */}
          <div className="text-center mb-12">
            <h3 className="text-2xl font-bold mb-6 text-gray-800">Exosome Oneの化粧品原料を選ぶ理由</h3>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white rounded-lg p-6 shadow-md">
                <i className="ri-rocket-line text-3xl text-pink-600 mb-4"></i>
                <h4 className="font-bold mb-3 text-gray-800">革新技術</h4>
                <p className="text-sm text-gray-600">
                  最先端のバイオテクノロジーによる従来にない美容効果を実現
                </p>
              </div>
              
              <div className="bg-white rounded-lg p-6 shadow-md">
                <i className="ri-leaf-line text-3xl text-teal-600 mb-4"></i>
                <h4 className="font-bold mb-3 text-gray-800">自然由来</h4>
                <p className="text-sm text-gray-600">
                  幹細胞由来の天然成分で肌に優しく環境にも配慮した製品
                </p>
              </div>
              
              <div className="bg-white rounded-lg p-6 shadow-md">
                <i className="ri-settings-line text-3xl text-purple-600 mb-4"></i>
                <h4 className="font-bold mb-3 text-gray-800">カスタマイズ</h4>
                <p className="text-sm text-gray-600">
                  ブランドコンセプトに合わせたオーダーメイドの成分開発
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}